<app-banner></app-banner>
@if (renderUniversityContent) {
<app-stats></app-stats>
<app-about-us></app-about-us>
<app-about-aikosh></app-about-aikosh>
<app-participate></app-participate>
 <!-- <app-benifits></app-benifits> -->
 <app-gain></app-gain>
<!-- <app-faculty-benefits></app-faculty-benefits> -->
<!-- <app-ai-future></app-ai-future> -->
<app-workshop-faq></app-workshop-faq>
<app-workshop-cta></app-workshop-cta>
<app-support></app-support>
<!-- <app-footer></app-footer> -->
}